import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router-dom';
import { goToRecruitLook, RL_COACH_DASHBOARD_PATH } from '@/lib/recruitlookHandoff';

const EventRegistrationSuccess: React.FC = () => {
  const { user } = useAuth();

  // Save debug data to localStorage for persistence
  const currentPageDebugData = {
    timestamp: new Date().toISOString(),
    pageName: 'EventRegistrationSuccess',
    hasUser: !!user,
    userId: user?.id,
    userEmail: user?.email,
    currentUrl: window.location.href,
    referrer: document.referrer
  };
  
  localStorage.setItem('event_success_debug', JSON.stringify(currentPageDebugData, null, 2));
  console.log('🎉 [EVENT-SUCCESS] Debug data saved to localStorage:', currentPageDebugData);

  // Collect all debug data from localStorage
  const getAllDebugData = () => {
    const debugKeys = [
      'debug_tier_selection',
      'debug_step2_formdata', 
      'debug_step6_rendering',
      'step6_debug_data',
      'step6_coach_processing_debug',
      'debug_registration_complete',
      'event_success_debug'
    ];
    
    const allDebugData: Record<string, any> = {};
    debugKeys.forEach(key => {
      const data = localStorage.getItem(key);
      if (data) {
        try {
          allDebugData[key] = JSON.parse(data);
        } catch (e) {
          allDebugData[key] = data;
        }
      }
    });
    
    return allDebugData;
  };

  const allDebugData = getAllDebugData();
  const [showDebug, setShowDebug] = useState(false);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-4xl space-y-4">
        <Card className="text-center">
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-primary mb-4">
              🎉 Registration Successful!
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <p className="text-muted-foreground">
              Your event registration has been completed successfully. 
              You will receive a confirmation email shortly.
            </p>

            <div className="space-y-3">
              {user && (
                <Button
                  className="w-full"
                  size="lg"
                  onClick={() => goToRecruitLook(RL_COACH_DASHBOARD_PATH)}
                >
                  Go to your coach dashboard
                </Button>
              )}

              <Link to="/events" className="block">
                <Button variant="outline" className="w-full">
                  Browse events
                </Button>
              </Link>

              <Link to="/">
                <Button 
                  variant="outline" 
                  className="w-full"
                >
                  Return to Home
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

      </div>
    </div>
  );
};

export default EventRegistrationSuccess;